<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Vendedores
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Vendedores</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="muestraModalAgrega(); showModalAgregar()" size="sm"
        mdbWavesEffect>
        Agregar
      </button>
    </div>
    <div class="row filtros-body">
      <div class="col" style="display:flex;">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="1" mdbInput />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
          <label class="form-check-label" for="materialInline2">Inactivos</label>
        </div>

        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <div class="md-form">
              <input value="" type="text" id="desc" class="form-control" [(ngModel)]="filtroNombre" placeholder="Nombre" required #desc />
              <label for="desc">Nombre</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn type="button" (click)="filtraxEstado()" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>


  </div>
</div>

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <input type="checkbox" (ngModel)="(true)" />

      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>

            <th scope="col" style="width: 20px;">Codigo</th>
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">Territorio</th>
            <th scope="col">Móvil corporativo</th>
            <th scope="col">Móvil personal</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vend of vendedorList">

            <td>{{ vend.codigo }}</td>
            <td>{{ vend.rutFormato | rut }}</td>
            <td>{{ vend.nombre }}</td>
            <td>{{ vend.territorioNombre }}</td>
            <td>{{ vend.fono1 }}</td>
            <td>{{ vend.fono2 }}</td>
            <td>
              <div *ngIf="vend.estado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!vend.estado">
                <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#basicExamplex" (click)="showModalModificar(); showForEdit(vend)"
                mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button *ngIf="!vend.estado" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(vend)" mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="vend.estado" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(vend)" mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<!-- Cabecera de botones -->

<!-- MODAL Agregar -->
<div mdbModal #centralLarge="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLarge.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formAgregarVendedor">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos del vendedor
                </h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estado" formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="number" id="codigo" class="form-control" formControlName="codigo" maxLength="10"
                    placeholder="Código" #codigo />
                  <label for="codigo">Código</label>
                  <div *ngIf="
                    frmAgregaCodigo.invalid &&
                    (frmAgregaCodigo.dirty || frmAgregaCodigo.touched)
                  ">
                    <mdb-error *ngIf="frmAgregaCodigo.errors.required">
                      El código es requerido
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input value="" type="text" id="rut" class="form-control" placeholder="Ingrese RUT sin puntos"
                    formControlName="rut" maxLength="10" (blur)="mascaraRut($event)" #rut tabindex="0" />
                  <label for="rut">RUT</label>
                  <div *ngIf="
                      frmAgregaRut.invalid &&
                      (frmAgregaRut.dirty || frmAgregaRut.touched)
                    ">
                    <mdb-error *ngIf="frmAgregaRut.errors.ValidaFormatoRut">
                      El RUT no es válido
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Nombre y Apellido" [(ngModel)]="nombreCompleto" class="form-control" type="text" id="nombre" formControlName="nombre"
                    maxLength="200" required value="" #nombre />
                  <label for="nombre">Nombre y Apellido</label>
                  <div *ngIf="
                      frmAgregaNombre.invalid &&
                      (frmAgregaNombre.dirty || frmAgregaNombre.touched)
                    ">
                    <mdb-error *ngIf="frmAgregaNombre.errors.required">
                      El nombre es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaNombre.errors.minlength">
                      El nombre debe tener un mínimo de 5 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaNombre.errors.maxlength">
                      El nombre no puede superar los 200 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <mdb-select label="Rubro" [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                    formControlName="listaRubro" placeholder="Rubro"></mdb-select>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <mdb-select formControlName="territorio" label="Territorio" [options]="optionsTerritorio"
                    placeholder="Territorio"></mdb-select>
                  <div *ngIf="
                      frmAgregaTerritorio.invalid &&
                      (frmAgregaTerritorio.dirty || frmAgregaTerritorio.touched)
                    ">
                    <mdb-error *ngIf="frmAgregaTerritorio.errors.required">El territorio es requerido</mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input value="" type="text" id="fono1" class="form-control" formControlName="fono1"
                    placeholder="Fono1" #fono1 />
                  <label for="fono1">Móvil corporativo</label>
                  <div *ngIf="
                      frmAgregaFono1.invalid &&
                      (frmAgregaFono1.dirty || frmAgregaFono1.touched)
                    ">
                    <mdb-error *ngIf="formAgregarVendedor.get('fono1').hasError('maxlength')">
                      El móvil corporativo no puede superar los 15 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="formAgregarVendedor.get('fono1').hasError('minlength')">
                      El móvil corporativo no puede tener menos de 8 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input value="" type="text" id="fono2" class="form-control" formControlName="fono2"
                    placeholder="Fono2" #fono2 />
                  <label for="fono2">Móvil personal</label>
                  <div *ngIf="
                      frmAgregaFono2.invalid &&
                      (frmAgregaFono2.dirty || frmAgregaFono2.touched)
                    ">
                    <mdb-error *ngIf="formAgregarVendedor.get('fono2').hasError('maxlength')">
                      El móvil personal no puede superar los 15 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="formAgregarVendedor.get('fono2').hasError('minlength')">
                      El móvil personal no puede tener menos de 8 caracteres
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLarge.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
          [disabled]="!formAgregarVendedor.valid" (click)="AbrirModalAgregarUsuario();">
          Siguiente
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL Editar -->
<div mdbModal #centralLargex="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formEditarVendedor">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Editar vendedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLargex.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos del vendedor
                </h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estadox"
                      formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="number" id="codigox" formControlName="codigo" class="form-control"
                    maxlength="10" #codigox />
                  <label for="codigox">Codigo</label>
                </div>
                <div class="md-form">
                  <input type="text" id="RUTx" formControlName="rut" class="form-control" title="Debe ser un Rut válido"
                    maxLength="10" required #rutx (blur)="mascaraRut($event)" />
                  <label for="rutx">RUT</label>
                  <div *ngIf="
                      frmEditarRut.invalid &&
                      (frmEditarRut.dirty || frmEditarRut.touched)
                    ">
                    <mdb-error *ngIf="frmEditarRut.errors.ValidaFormatoRut">
                      El RUT no es válido
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Nombre" formControlName="nombre" class="form-control" type="text" id="nombrex"
                    maxLength="200" #nombrex />
                  <label for="nombrex">Nombre</label>
                  <div *ngIf="
                      frmEditarNombre.invalid &&
                      (frmEditarNombre.dirty || frmEditarNombre.touched)
                    ">
                    <mdb-error *ngIf="frmEditarNombre.errors.required">
                      El nombre es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarNombre.errors.maxLength">
                      El nombre no puede superar los 200 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarNombre.errors.minlength">
                      El nombre debe tener un mínimo de 3 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <mdb-select label="Rubro" [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                    formControlName="listaRubro" placeholder="Rubro"></mdb-select>
                </div>
              </div>
              <div class="col">
                <div class="md-form-select">
                  <mdb-select formControlName="territorio" [options]="optionsTerritorio" placeholder="Territorio">
                  </mdb-select>
                  <label>Territorio</label>
                  <div *ngIf="
                      frmEditarTerritorio.invalid &&
                      (frmEditarTerritorio.dirty || frmEditarTerritorio.touched)
                    ">
                    <mdb-error *ngIf="frmEditarTerritorio.errors.required">El territorio es requerido</mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input type="text" id="fono1x" formControlName="fono1" class="form-control" maxLength="15"
                    placeholder="Fono1" #fono1x />
                  <label for="fono1x">Móvil corporativo</label>
                  <div *ngIf="
                      frmEditarFono1.invalid &&
                      (frmEditarFono1.dirty || frmEditarFono1.touched)
                    ">
                    <mdb-error *ngIf="frmEditarFono1.errors.maxlength">
                      El móvil corporativo no puede superar los 15 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarFono1.errors.minlength">
                      El móvil corporativo no puede tener menos de 8 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input type="text" id="fono2x" formControlName="fono2" class="form-control" maxLength="15"
                    placeholder="Fono2" #fono2x />
                  <label for="fono2x">Móvil personal</label>
                  <div *ngIf="
                      frmEditarFono2.invalid &&
                      (frmEditarFono2.dirty || frmEditarFono2.touched)
                    ">
                    <mdb-error *ngIf="frmEditarFono2.errors.maxlength">
                      El móvil personal no puede superar los 15 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmEditarFono2.errors.minlength">
                      El móvil personal no puede tener menos de 8 caracteres
                    </mdb-error>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLargex.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
          [disabled]="!formEditarVendedor.valid" (click)="actualizar(); centralLargex.hide()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<app-usuarios-vendedor (onSave)="UserSaveComplete()" (onSuccess)="VendedorSave()"></app-usuarios-vendedor>
